import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import store from "./store"
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
  QueryClient,
  QueryClientProvider,
} from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools'
import { TwilioProvider } from "./hoc/Context/TwilioContext"
import { BrowserRouter as Router } from 'react-router-dom';
import StatusProvider from './hoc/Status';

const queryClient = new QueryClient()

ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <React.StrictMode>
        <TwilioProvider>
            <Router>
              <StatusProvider>
                <App />
              </StatusProvider>
            </Router>
        </TwilioProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </React.StrictMode>
    </Provider>
  </QueryClientProvider>,
  document.getElementById('root')
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
